const DEFAULT_COVER_ART =
  "https://images.unsplash.com/photo-1618126348449-f600c78a798c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxteXN0aWNhbCUyMHJlZCUyMHJvc2UlMjBjYW5kbGUlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3OTE5MTAxNTB8MA&ixlib=rb-4.1.0&q=85";

function CrescentMark({ className = "w-8 h-8" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <path
        d="M42 8a26 26 0 1 0 12 40A30 30 0 0 1 42 8z"
        fill="none"
        stroke="#D6AF62"
        strokeWidth="2.5"
      />
      <circle cx="46" cy="16" r="1.6" fill="#D6AF62" />
      <circle cx="54" cy="26" r="1.1" fill="#D6AF62" />
    </svg>
  );
}

export function CoverFace({ coverUrl, className = "", minimal = false }) {
  if (coverUrl) {
    return (
      <img
        src={coverUrl}
        alt="Capa do e-book Meu Ex de Volta — 50 Simpatias para Reconquistar um Amor"
        className={`h-full w-full object-cover ${className}`}
        loading="lazy"
      />
    );
  }
  if (minimal) {
    return (
      <div className={`relative flex h-full w-full flex-col items-center justify-center gap-4 overflow-hidden bg-vinho ${className}`}>
        <img
          src={DEFAULT_COVER_ART}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover opacity-45"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian/80 via-vinho/55 to-obsidian/90" />
        <CrescentMark className="relative z-10 h-8 w-8 anim-glow" />
        <p className="relative z-10 text-center font-cinzel text-[0.6rem] tracking-[0.35em] text-dourado/90">
          EDIÇÃO
          <br />
          DIGITAL
        </p>
      </div>
    );
  }
  return (
    <div className={`relative flex h-full w-full flex-col items-center justify-between overflow-hidden bg-vinho ${className}`}>
      <img
        src={DEFAULT_COVER_ART}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover opacity-45"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-obsidian/70 via-vinho/45 to-obsidian/85" />
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 40%, rgba(247,239,228,0.18), transparent 62%)",
        }}
      />
      <div className="relative z-10 flex w-full flex-col items-center px-5 pt-11">
        <CrescentMark className="h-8 w-8 anim-glow" />
        <p className="mt-4 text-center font-cinzel text-[0.6rem] tracking-[0.35em] text-dourado/90">
          EDIÇÃO DIGITAL
        </p>
      </div>
      <div className="relative z-10 px-4 text-center">
        <p
          className="font-cinzel text-xl leading-snug text-creme sm:text-2xl"
          style={{ textShadow: "0 0 20px rgba(214,175,98,0.5), 0 2px 8px rgba(0,0,0,0.6)" }}
        >
          MEU EX
          <br />
          DE VOLTA
        </p>
        <div className="gold-line mx-auto my-3 w-16" />
        <p
          className="font-serif text-[0.65rem] uppercase tracking-[0.2em] text-dourado"
          style={{ textShadow: "0 0 14px rgba(214,175,98,0.6)" }}
        >
          50 Simpatias para
          <br />
          Reconquistar um Amor
        </p>
      </div>
      <div className="relative z-10 pb-6 text-center">
        <p className="text-[0.5rem] uppercase tracking-[0.3em] text-creme/60">
          Rituais · Orações · Recomeços
        </p>
      </div>
    </div>
  );
}

export function BookMockup({ coverUrl = "", width = 240, testId = "book-mockup", minimal = false }) {
  const height = Math.round(width * 1.45);
  return (
    <div className="book-scene" data-testid={testId} style={{ width, height }}>
      <div className="book3d" style={{ width, height }}>
        <div className="book-back" />
        <div className="book-spine" />
        <div className="book-pages" />
        <div className="book-front">
          <CoverFace coverUrl={coverUrl} minimal={minimal} />
        </div>
      </div>
    </div>
  );
}
